<template>
    <NuxtMicroFrontendLoader data-testid="project-view-profile-mf" class="profile-mf" :mf-url="`/profile/mf/profile/${profileId}`">
        <template #loading>
            <VJoyBlockSkeleton v-for="index in 4" :key="index" class="profile-mf__skeleton-section" />
        </template>
    </NuxtMicroFrontendLoader>
</template>

<script setup lang="ts">
    import {VJoyBlockSkeleton} from '@maltjoy/core-vue';

    defineProps<{profileId: string}>();
</script>

<style scoped lang="scss">
    .profile-mf {
        flex: 1 1 auto;
        height: 100%;
        overflow: hidden;
        padding-top: var(--joy-core-spacing-4);

        &__skeleton-section {
            height: 24px;
            margin-bottom: var(--joy-core-spacing-4);
        }
    }
</style>
